import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { I18nService } from '../core/i18n/i18n.service';
import { ToastService } from '../core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (toast.items().length) {
      <div class="toast-stack" aria-live="polite" aria-atomic="true">
        @for (item of toast.items(); track item.id) {
          <div class="toast" [class]="'toast toast--' + item.tone" role="alert">
            <p class="toast__message" [innerHTML]="item.message"></p>
            <button
              type="button"
              class="toast__close"
              [attr.aria-label]="i18n.translate('toast.dismiss')"
              (click)="toast.dismiss(item.id)"
            >
              ×
            </button>
          </div>
        }
      </div>
    }
  `
})
export class ToastContainerComponent {
  readonly i18n = inject(I18nService);
  readonly toast = inject(ToastService);
}
